import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {User, UserService} from "../services/user.service";
import {map, zip} from "rxjs";
import {
  getMissingFields,
  hasValidEmail,
  ProfileRequirements,
  ProfileRequirementsService
} from "../services/profile-requirements.service";



export const profileRequirementsGuard: CanActivateFn = (route, state) => {

  const $users = inject(UserService) ;
  const $requirements = inject(ProfileRequirementsService);
  const $router = inject(Router);


  return zip($users.getUser(),$requirements.getRequirementsFromRoute(route))
    .pipe(
      map(result => {

        const user = result[0] as User | undefined;
        const requirements = result[1] as ProfileRequirements;

        if (!user) {
          const url = $router.parseUrl('/auth');
          url.queryParams = {
            returnUrl: state.url
          }
          return url ;
        }

        if (!requirements) {
          return true;
        }

        if (!hasValidEmail(user, requirements)) {
          const url = $router.parseUrl('/auth');
          url.queryParams = {
            returnUrl: state.url
          }
          return url ;
        }

        if (getMissingFields(user, requirements).length) {
          const url = $router.parseUrl('/edit-profile');
          url.queryParams = {
            returnUrl: state.url
          }
          return url ;
        }

        return true ;

      })
    );
};
